import { useLocation } from 'react-router-dom';
import { useProjectSiteNavigation } from '@/shared/lib';
import type { NavigationItemWithState } from '@/entities/navigation';
import { useMemo } from 'react';

export const useNavigationItem = (item: NavigationItemWithState) => {
  const { navigateWithContext, buildPath } = useProjectSiteNavigation();
  const location = useLocation();

  const hasSubItems = !!(item.subItems && item.subItems.length > 0);
  const currentPath = buildPath(item.path || '');
  const isCurrentPath = currentPath === location.pathname;
  const isActive = useMemo(() => {
    if (hasSubItems) {
      return item.subItems?.some((subItem) => buildPath(subItem.path || '') === location.pathname);
    }
    return item.isActive || isCurrentPath;
  }, [hasSubItems, isCurrentPath, item.isActive, item.subItems, buildPath, location.pathname]);

  const handleClick = (onToggle: (code: string) => void) => {
    if (hasSubItems) {
      onToggle(item.code);
    } else if (item.path) {
      navigateWithContext(item.path);
    }
  };

  return {
    hasSubItems,
    isActive,
    isExpanded: item.isExpanded,
    handleClick
  };
};
